import React from 'react';
import ReactApexChart from 'react-apexcharts';
import useInsights from '../../hooks/useInsights';

const BookingBarChart = () => {
  const { data, isLoading, error } = useInsights();

  if (isLoading) return <p>Loading chart...</p>;
  if (error) return <p className="text-red-500">Error loading data</p>;

  const series = [
    {
      name: 'Completed Bookings',
      data: [
        data?.completedBookingsToday ?? 0,
        data?.completedBookingsThisWeek ?? 0,
        data?.completedBookingsThisMonth ?? 0
      ],
    },
  ];

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 12,
        columnWidth: '20%',
        endingShape: 'rounded',
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        colors: ['#555'],
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: "vertical",
        shadeIntensity: 0.3,
        gradientToColors: ['#298E9F', '#60A5FA', '#298E9F'],
        inverseColors: false,
        opacityFrom: 0.8,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    colors: ['#34D399'], // base gradient start color
    xaxis: {
      categories: ['Today', 'This Week', 'This Month'],
      labels: {
        style: {
          fontSize: '13px',
          colors: ['#6B7280'],
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '12px',
          colors: ['#6B7280'],
        },
      },
    },
    tooltip: {
      theme: 'light',
      y: {
        formatter: (val) => `${val} Bookings`,
      },
    },
    grid: {
      borderColor: '#E5E7EB',
      strokeDashArray: 5,
    },
  };

  return (
    <div className="p-6 rounded-2xl   w-[100%]">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">Completed Bookings </h2>
      <ReactApexChart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default BookingBarChart;
